export default __webpack_public_path__ + "static/media/layer3.7e080c18.svg";